import React from "react";


export const IconColumnFormatter = (cellContent, row) => (
  <>
    <img src={row.icon} style={{width: "50px"}} alt="icon_image" />
  </>
);
